import { useCallback, useState } from 'react'

export const useManagerActions = () => {
  const [showSelectManagerModal, setShowSelectManagerModal] = useState(false)

  const openManagerSelectModal = useCallback(() => {
    setShowSelectManagerModal(true)
  }, [])

  const closeManagerSelectModal = useCallback(() => {
    setShowSelectManagerModal(false)
  }, [])

  return { showSelectManagerModal, closeManagerSelectModal, openManagerSelectModal }
}
